/**
 * `digest` del error que lanzan las páginas de `(general-web)` cuando la
 * página de error NO debe cachearse (`resolveErrorPageOutcome`). Next.js
 * respeta un `digest` propio y lo entrega tal cual a `error.tsx`, que por ser
 * Client Component no recibe ninguna otra propiedad del error de servidor —
 * así puede mostrar el código real (403, 503…) en vez de un 500 fijo.
 *
 * Fichero sin dependencias de servidor a propósito: lo importa `error.tsx`
 * (ver el comentario de ese archivo sobre el barrel `index.ts`).
 */
const ERROR_PAGE_DIGEST_PREFIX = 'ECI_PAGE_ERROR:'

export function buildErrorPageDigest(code: number | string): string {
  return `${ERROR_PAGE_DIGEST_PREFIX}${code}`
}

/** Código codificado en `digest`, o `null` si el error no viene de
 * `buildErrorPageDigest` (cualquier otro error no capturado). */
export function parseErrorPageDigest(digest: string | undefined): number | string | null {
  if (!digest?.startsWith(ERROR_PAGE_DIGEST_PREFIX)) return null
  const raw = digest.slice(ERROR_PAGE_DIGEST_PREFIX.length)
  if (!raw) return null
  const numeric = Number(raw)
  return Number.isInteger(numeric) ? numeric : raw
}
